import React from 'react';
import { PageHero } from '../components/PageHero';
import { SectionStage } from '../components/SectionStage';
import { SectionLabel, SectionHeading } from '../components/ui/UI';
export function SampleReport() {
  return <>
      <PageHero eyebrow="Sample Data" title="Validation Snapshot" titleMuted="Sample Report" description="This is a sample Validation Snapshot. It demonstrates the structure, depth, and clarity of the evidence Periscan delivers." bg="none" data-id="element-1746" />

      <SectionStage fx="squares" data-id="element-1747">
        <section className="relative w-full py-32 border-t border-white/5" data-id="element-1748">
          <div className="max-w-7xl mx-auto px-6 lg:px-8" data-id="element-1749">
            <SectionLabel number="01" label="Executive Summary" className="mb-8" data-id="element-1750" />
            <div className="grid grid-cols-1 lg:grid-cols-12 gap-12" data-id="element-1751">
              <div className="lg:col-span-8" data-id="element-1752">
                <SectionHeading size="xl" data-id="element-1753">
                  Clear answers.
                  <br data-id="element-1754" />
                  <span className="text-white/40" data-id="element-1755">
                    No decoder ring required.
                  </span>
                </SectionHeading>
              </div>
            </div>
            {/* Placeholder for report content */}
            <div className="mt-12 p-8 rounded-2xl bg-[#070a0e] border border-white/5 text-white/60" data-id="element-1756">
              [Sample Report Content: Executive summary, Top validated paths,
              Control verdicts, AI app validation, Remediation priorities,
              Verification plan, Evidence appendix, Methodology and safety
              notes]
            </div>
          </div>
        </section>
      </SectionStage>
    </>;
}